import React from 'react';
import img404 from '../../images/page404.png';

const PageNotFound = () => {
    return (
        <div>
            <img style={{width:'62%'}} src={img404} alt="" />
        </div>
    );
};

export default PageNotFound;